import { z } from 'zod/v4';

import { foldSynonyms, isNumber, isString, normalizeFlatArgs } from '../widget-schemas/fold-helpers';
import { INDEX_SYNONYM_KEYS } from '../widget-schemas/reorder-widget.schema';

import { COLUMN_ID_SYNONYM_KEYS } from './remove-column.schema';

const SECTION_ID_SYNONYM_KEYS = ['targetSectionId', 'section_id'] as const;

const reorderColumnObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to move.'),
    index: z
        .number()
        .int()
        .min(0)
        .describe(
            "Destination position among the section's columns (0-based, counted with this column already " +
                'taken out of the list). Larger than the list is clamped to the end.'
        ),
    sectionId: z
        .string()
        .optional()
        .describe('Move the column into this section. Omit to reposition it within the section it is already in.'),
});

export const reorderColumnArgsSchema = z.preprocess(
    (raw) =>
        normalizeFlatArgs(raw, (args) => {
            foldSynonyms(args, args, 'columnId', COLUMN_ID_SYNONYM_KEYS, isString);
            foldSynonyms(args, args, 'index', INDEX_SYNONYM_KEYS, isNumber);
            foldSynonyms(args, args, 'sectionId', SECTION_ID_SYNONYM_KEYS, isString);
        }),
    reorderColumnObjectSchema
);
